import { BaseNode, NodeBadge } from './BaseNode';

export function FailNode({ data }: { data: { label: string; message?: string; code?: string } }) {
  return (
    <BaseNode
      type="fail"
      label={data.label}
      hasSource={false}
      badge={data.code && <NodeBadge>{data.code}</NodeBadge>}
      lines={[{ text: data.message }]}
    />
  );
}
